import { action } from 'typesafe-actions';
import { ResponseError } from '../../../services/api';
import { BudgetFieldsTypes, FormFields } from './types';

export const loadFieldsRequest = () => action(BudgetFieldsTypes.LOAD_REQUEST);
export const setValues = (values: any[]) => action(BudgetFieldsTypes.SET_VALUES, { values });
export const loadFieldsSuccess = (data: FormFields[]) => action(BudgetFieldsTypes.LOAD_SUCCESS, { data });
export const loadFieldsFailure = (error: ResponseError) =>
  action(BudgetFieldsTypes.LOAD_FAILURE, { error });
